import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";

const InstallPopup = ({ showInstallMessage, handleInstallMessageClose }) => {
  return (
    <Dialog
      open={showInstallMessage}
      onClose={handleInstallMessageClose}
      aria-labelledby="App Installer"
      maxWidth={false}
    >
      <DialogContent>
        <Typography variant="body2">
          To install this webapp on your phone, tap the share button and then
          Add to homescreen.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleInstallMessageClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InstallPopup;
